import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function TooltipContent({
  value
}) {
  const portalTz = I18n.moment['portalTz'](value).format('L LT z');
  const userObjectTz = I18n.moment['userObjectTz'](value).format('L LT z');
  return /*#__PURE__*/_jsxs("div", {
    style: {
      minWidth: 400
    },
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.userObjectTzCell.user"
    }), ": ", userObjectTz, /*#__PURE__*/_jsx("br", {}), portalTz === userObjectTz ? /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.userObjectTzCell.timezoneMatch"
      })
    }) : /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.userObjectTzCell.portal"
      }), ": ", portalTz]
    })]
  });
}
export function UserObjectTzCell(props) {
  var _props$crmObject$prop;
  const value = (_props$crmObject$prop = props.crmObject.properties[props.propertyName]) === null || _props$crmObject$prop === void 0 ? void 0 : _props$crmObject$prop.value;
  const timestamp = value && parseInt(value, 10);
  if (!timestamp) {
    return /*#__PURE__*/_jsx("span", {
      children: "--"
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(TooltipContent, {
      value: timestamp
    }),
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: timestamp,
          type: "userObjectTz",
          format: "LL"
        })
      }), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: timestamp,
          type: "userObjectTz",
          format: "LT"
        })
      })]
    })
  });
}
export function UserObjectTzHeader(props) {
  var _props$column$propert;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(_props$column$propert = props.column.propertyDescriptor) === null || _props$column$propert === void 0 ? void 0 : _props$column$propert.label, ` (${I18n.moment.userObjectTz().format('z')})`]
  });
}